<div class="siteIntegrations">
  <section class="siteIntegrations__frame">
    <section class="siteIntegrations__logos">
      <div class="logoWrapper">
        @if (rebrandEnabled()) {
          <pp-icon
            role="img"
            aria-label="Voly Finance logo"
            [ppSVG]="iconMap[EIconPath.ICON_BADGE_LOGO_VOLY_FINANCE]"
          ></pp-icon>
        } @else {
          <img [src]="EIconPath.ICON_BADGE_LOGO_VOLY_BLACK" />
        }
      </div>

      <img [src]="EIconPath.ICON_COLORED_COMPARE_ARROWS" />

      <div class="logoWrapper">
        @if (rebrandEnabled()) {
          <img [src]="EIconPath.LOGO_HORIZONTAL_COLOUR_REBRAND_PNG" />
        } @else {
          <img [src]="EIconPath.ICON_BADGE_LOGO_PINPOINT_BLACK" />
        }
      </div>
    </section>

    @if (step === EIntegrationStep.GET_STARTED) {
      <pp-site-settings-integrations-get-started
        [ppDisabled]="disableInteractionButton"
        (ppEnableIntegration)="onIntegrationStart()"
      >
      </pp-site-settings-integrations-get-started>
    }

    @if (step === EIntegrationStep.AUTHORIZE_CONNECTION) {
      <pp-site-settings-integrations-authorize-connection
        [ppDisabled]="disableInteractionButton"
        [(ppIntegrationStep)]="integrationStep"
        [ppWorkspaceId]="workspace.workspaceId"
      ></pp-site-settings-integrations-authorize-connection>
    }

    <pp-site-settings-integrations-custom-fields
      [ppWorkspaceId]="workspace.workspaceId"
      [ppIntegrationStep]="integrationStep"
      [ppDisabled]="disableInteractionButton"
    ></pp-site-settings-integrations-custom-fields>

    @if (canSeeAuditLog) {
      <pp-site-settings-integrations-audit-log
        [ppWorkspaceId]="workspace.workspaceId"
      ></pp-site-settings-integrations-audit-log>
    }
  </section>
</div>
